module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__shopsquare"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "shoes",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/assets/imgs/case-study/shopsquare/shoes.png",
      "srcset": "/assets/imgs/case-study/shopsquare/shoes@2x.png 2x",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "case-study__video-row"
  }, [_c('case-study-video', {
    staticClass: "case-study__row"
  }, [_c('source', {
    attrs: {
      "src": "/assets/videos/case-study/shopsquare/desktop-xp.mp4",
      "type": "video/mp4"
    }
  })])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "case-study__row case-study__video-row case-study__video-half-row"
  }, [_c('case-study-video', {
    staticClass: "case-study__video-half"
  }, [_c('source', {
    attrs: {
      "src": "/assets/videos/case-study/shopsquare/mobile-xp.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__video-half"
  }, [_c('source', {
    attrs: {
      "src": "/assets/videos/case-study/shopsquare/mobile-search.mp4",
      "type": "video/mp4"
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("My work at Shopsquare")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n\t\t\tI’ve worked for shopsquare for 6 months as a fullstack developer. Shopsquare was built completely in Laravel, a great PHP framework. This is a good technical choice when you have a classic e-commerce website. Shopsquare has to deal with millions of products that come from multiple data sources and respond in a second. So one of my missions was to combine Laravel to Algolia.\n\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("What I learned")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n\t\t\tMore than technical knowledge, what I learned at Shosquare is how a Startup work. Further than the classical ping-pong-table, I have integrated a great team of motivated people who get up in the morning with one purpose: enhance their product, take decisions and learn from their mistakes.\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13c84e44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/CaseStudy/Shopsquare.vue
// module id = 262
// module chunks = 0